import React from "react";
import Menu from "../Menu";
import CommonSendComponent from "../../components/CommonSendComponent";
import { getSendConfig } from "../../Configs/SendConfigs";

const SendFirmware = () => {
  const config = getSendConfig('firmware');

  return (
    <>
      <Menu />
      <CommonSendComponent config={config} />
    </>
  );
};

export default SendFirmware;
